import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-delegate-create-plan2',
  templateUrl: './delegate-create-plan2.component.html',
  styleUrls: ['./delegate-create-plan2.component.scss']
})
export class DelegateCreatePlan2Component implements OnInit {
  sectionTitle = 'Why choose Zenplans'
  delegateCreatePlan2 = {
    title: 'Call to action',
    dataInfo: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.'
  }
  constructor() { }

  ngOnInit() {
  }

}
